import Wizard from './WizardParts/Wizard';
import WizardContext from './WizardParts/WizardContext';
import WizardPage from './WizardParts/WizardPage';
import NextButton from './WizardParts/NextButton';
import SubmitButton from './WizardParts/SubmitButton';
import PreviousButton from './WizardParts/PreviousButton';
import withWizardContext from './WizardParts/WithWizardContext';
import WizardNavTracker from './WizardParts/WizardNavTracker';

const WizardNextButton = withWizardContext(NextButton);
const WizardSubmitButton = withWizardContext(SubmitButton);
const WizardPreviousButton = withWizardContext(PreviousButton);

export {
  WizardContext,
  WizardPage,
  WizardNextButton,
  WizardSubmitButton,
  WizardPreviousButton,
  WizardNavTracker
};
export default Wizard;
